module.exports = __webpack_public_path__ + "static/media/microblading.2720da11.jfif";